// extracted by mini-css-extract-plugin
export default {"mobile":"_3pvKA","root":"_3bCmS","onImage":"_2Uksm"};